@if (!!isMobile || !hideInDesktop) {
  <div
    id="main-nav"
    tabindex="-1"
    class="flex justify-between h-14 items-center !z-50 px-2"
    [ngClass]="!displayBackground ? 'bg-transparent' : 'bg-white'"
    [class]="direction"
    >
    <div
      class="flex items-center gap-2"
      [ngClass]="{ 'text-white': !displayBackground }"
      >
      <!--
        a11y: only render the header icon button when consumers actually pass
        an icon. Previously this <mot-button> was always rendered, and when
        no [icon] was set (slide-up-cards like search-line-results-container
        that have their own internal back chevron via app-results-header)
        mot-button still rendered a 40x40 mat-icon-button with NO visible
        glyph — a "phantom" button that took up space at the top-right,
        announced itself as "back" to screen readers, but did nothing on
        click (the parent didn't bind (onHeaderButtonClick)). Audit flagged
        this as "button with no accessible name and no visual representation"
        because sighted users couldn't see it and SR users were confused by
        an inert "back" button. Wrapping in @if (icon) skips the entire
        button when no icon is provided.

        focusInitial is forwarded by mot-button as [attr.cdkFocusInitial] on
        its INNER native <button>. The previous template put a bare
        `cdkFocusInitial` on the <mot-button> custom element host (not
        focusable), so the dialog opened with focus stranded behind it.
      -->
      @if (icon) {
        <mot-button
          matType="icon"
          [focusInitial]="focusInitialOnBack"
          [iconClass]="!displayBackground ? 'text-white' : ''"
          [icon]="icon"
          [ariaLabel]="resolvedBackButtonAriaLabel"
          (onClick)="onHeaderButtonClick.emit()"
        >
        </mot-button>
      }
      @if (title) {
        <h2
          class="text-base m-0"
          style="color: currentColor"
          [attr.id]="dialogTitleElementId || null"
          >
          {{ title }}
        </h2>
      }
    </div>
    <ng-content></ng-content>
    @if (!!showLogo) {
      <!--
        a11y: audit required either a hidden H1 per tab or the logo declared as
        the page's H1 heading. On desktop the equivalent <h1> lives in
        nav-bar.component.html; on mobile the nav-bar is hidden and this
        route-planner-header becomes the top-most landmark, so the logo is
        promoted to <h1> here to keep parity across viewports and tabs (tabs
        within the planner share this single page heading).
        leading-none + h-full keep the heading wrapper inline with the toolbar
        so we don't introduce any extra vertical spacing.
      -->
      <h1 class="m-0 p-0 flex items-center h-full leading-none">
        <button
          type="button"
          class="m-0 p-0 border-0 bg-transparent w-28 h-full flex items-center cursor-pointer"
          [attr.aria-label]="logoHomeAriaLabel"
          (click)="navigateToWebsite()"
        >
          <img
            [src]="
              !!displayBackground
                ? '/assets/images/logo.svg'
                : '/assets/images/logo-white.svg'
            "
            alt=""
            aria-hidden="true"
            class="w-28 h-full"
            />
        </button>
      </h1>
    }
    </div>
  }
